import React from "react";
import { MarkerType } from "react-flow-renderer";

import { Link } from "react-router-dom";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "#f5cc7f";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Basics of CSS!</strong>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 300,
    },
  },

  {
    id: "2",

    data: {
      label: (
        <>
          <strong>Margin</strong>
          <p className="">
            Margin represents the outermost layer of any webpage.
          </p>
          <p>
            In order to remove white space around webpages you must set a value
            of 0px for margin because the DEFAULT value for margin is 8px.
          </p>
        </>
      ),
    },
    position: { x: 753, y: 170 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "3",

    data: {
      label: (
        <>
          <strong>margin</strong>
          <p className=""></p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="margin"
            src="https://codepen.io/jonathanelias1/embed/preview/gOzoJyo?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/gOzoJyo">margin</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 604, y: 700 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  // {
  //   id: "3",

  //   data: {
  //     label: (
  //       <>
  //         <strong>margin-top</strong>
  //         <p>Add space above an element</p>
  //         <p>{`element{margin-top: 50px;}`}</p>
  //         <div className="grid-template-columns">
  //           <div className="css-grid-item-margin">Element in webpage </div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 380, y: 700 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 500,
  //   },
  // },

  // {
  //   id: "4",

  //   data: {
  //     label: (
  //       <>
  //         <strong>margin-bottom</strong>
  //         <p>Add space below an element</p>
  //         <p className="css-code">{`.element{margin-bottom: 50px;}`}</p>
  //         <div className="grid-template-columns">
  //           <div className="css-grid-item-margin-bottom">
  //             Element in webpage{" "}
  //           </div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 670, y: 700 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "5",

  //   data: {
  //     label: (
  //       <>
  //         <strong>margin-right</strong>
  //         <p>Add space to the right of an element</p>
  //         <p className="css-code">{`.element{margin-right: 50px;}`}</p>
  //         <div className="grid-template-columns">
  //           <div className="css-grid-item-margin-right">
  //             Element in webpage{" "}
  //           </div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 670, y: 430 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "6",

  //   data: {
  //     label: (
  //       <>
  //         <strong>margin-left</strong>
  //         <p>Add space to the left of an element</p>
  //         <p className="css-code">{`.element{margin-left: 50px;}`}</p>
  //         <div className="grid-template-columns">
  //           <div className="css-grid-item-margin-left">Element in webpage </div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 380, y: 430 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  {
    id: "7",

    data: {
      label: (
        <>
          <strong>CSS classes</strong>
          <p className="css-info">
            To use CSS to stylize our elements we must create and target html
            elements in our webpage. <br /> <br />
            These can be identified in classes you name or in prenamed elements
            like headers, paragraphs, divs, sections, images, etc.
            <br /> <br />
            General style change example: p{`{color: red}`} <br />
            h1{`{font-family:Arial}`} <br />
            div{`{background-color: red}`}.
            <br />
            <br />I prefer to target specific elements by giving them curated
            class names. So, I would give a class of something like paragraph-1
            for my first paragraph and paragraph-2 for my second paragraph and
            then access them through their class name in my css with .paragraph1
            {`{}`} and .paragraph2
            {`{}`}.<br />
            <br />
            Ultimately, it's just a matter of preference. In the following
            flowcharts you will often encounter me using a mix of class names
            and prenamed elements but don't be confused, either of these can
            work.
          </p>
          {/* <p className="css-code">
            In the width and height boxes below notice how I gave the boxes class names of box1, box2, box3, and box4. 
          </p> */}
        </>
      ),
    },
    position: { x: -250, y: 170 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "8",

    data: {
      label: (
        <>
          <strong>Targeting Multiple Elements at once</strong>
          <p className="">
            There are several ways to target multiple CSS elements on a webpage
            at once.
          </p>
        </>
      ),
    },
    position: { x: -56, y: 1350 },
    style: {
      background: level3,
      //fix the background level later
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "9",

    data: {
      label: (
        <>
          <strong>
            Give Multiple Elements the same CSS property with a comma separator
          </strong>
          <p className="">
            You can do p, h1{`{background-color:red}`} this will target the
            paragraph and h1 heading and make both of their background colors
            red. <br /> <br />
            You can also replace the p and/or h1 with whatever class name you
            want and can also add more html targets. <br /> <br />
            As long as you put the comma between elements you can give as many
            as you want the same property.
          </p>
          <p>
            Example: <br /> .big-text, .small-text, p, div <br />
            {`{display: inline; `} <br />
            {`background-color: blue;}`} <br />
          </p>
        </>
      ),
    },
    position: { x: -258, y: 1812 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "10",

    data: {
      label: (
        <>
          <strong>
            Give Multiple Elements the same CSS property through the HTML Body
          </strong>
          <p className="teest">
            The {`<body>`} tag defines the document's body and contains all the
            contents of an HTML document, such as headings, paragraphs, images,
            hyperlinks, tables, lists, etc. Since there can only be one &nbsp;
            {`<body>`} element in an HTML document, you can target the webpage
            contents through the body.
            <br />
            <br />
            <p>
              {" "}
              Example: <br />
              {`body{margin: 0px;`}
              <br />
              {`background-color: black;}`}
            </p>
          </p>
        </>
      ),
    },
    position: { x: -672, y: 1812 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "11",

    data: {
      label: (
        <>
          <strong>
            Give Multiple Elements the same CSS property through the *
          </strong>
          <p className="teest">
            If you need to select all of the html elements you can do this
            through the *.
          </p>
          <p>
            Example: This would make all of the text in the entire webpage
            black. <br />
            {`*{color: black;}
            `}
          </p>
        </>
      ),
    },
    position: { x: 566, y: 1812 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "12",

    data: {
      label: (
        <>
          <strong>Display</strong>
          <p className="">
            There's multiple display options for elements to align them on a
            webpage.
          </p>
        </>
      ),
    },
    position: { x: 1744, y: 170 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 300,
    },
  },

  {
    id: "13",

    data: {
      label: (
        <>
          <strong>display:</strong>
          <p className=""></p>
          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="display"
            src="https://codepen.io/jonathanelias1/embed/preview/poVaapZ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/poVaapZ">display</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1442, y: 652 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 900,
    },
  },

  // {
  //   id: "13",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: block</strong>
  //         <p className="">
  //           Displays an element as a block element where it starts on a new
  //           line, and takes up the whole width.
  //         </p>

  //         <p>{`span{display: block}`}</p>

  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-block-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display block on it. You can tell from
  //           the background that it takes up the whole width.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1190, y: 310 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 600,
  //   },
  // },

  // {
  //   id: "14",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: inline</strong>
  //         <p className="">
  //           Displays an element as an inline element where any height and width
  //           properties will have no effect.
  //         </p>
  //         <p className="css-code">span{`{display: inline}`}</p>
  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-inline-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display: inline on it.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1560, y: 310 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "15",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: inline-block</strong>
  //         <p className="">
  //           Displays an element as an inline-level block container. The element
  //           itself is formatted as an inline element, but you can apply height
  //           and width values to it.
  //         </p>
  //         <p className="css-code">span{`{display: inline-block}`}</p>
  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-inline-block-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display: inline-block on it.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1375, y: 310 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "16",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: list-item</strong>
  //         <p className="">makes the element behave like a {`<li>`} element</p>
  //         <p className="css-code">span{`{display: list-item}`}</p>
  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-list-item-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display: list-item on it.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1560, y: 600 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "17",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: grid</strong>

  //         <p className="">
  //           {" "}
  //           Displays an element as a block-level grid container. I explain CSS
  //           Grid more here
  //           <Link className="link-to-css-grid" to="/cssgrid">
  //             CSS Grid
  //           </Link>
  //         </p>
  //         <p className="css-code">span{`{display: grid}`}</p>
  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-grid-1-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display: grid on it.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1190, y: 600 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "18",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: flex</strong>
  //         <p className="">
  //           Displays an element as a block-level flex container. I explain
  //           Flexbox more here
  //           <Link className="link-to-flexbox" to="/flexbox">
  //             Flexbox
  //           </Link>
  //         </p>
  //         <p className="css-code">span{`{display: flex}`}</p>
  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-flex-1-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display: flex on it.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1375, y: 600 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  // {
  //   id: "19",

  //   data: {
  //     label: (
  //       <>
  //         <strong>display: inherit</strong>
  //         <p className="">
  //           Will make an element inherit the property from its parent element.
  //         </p>
  //         <p className="css-code">span{`{display: inherit}`}</p>
  //         <p>
  //           Inside this paragraph I have placed this
  //           <span className="display-inherit-example">
  //             blue text in a span element
  //           </span>
  //           to illustrate the result of display: inherit on it.
  //         </p>
  //       </>
  //     ),
  //   },
  //   position: { x: 1360, y: 880 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 180,
  //   },
  // },

  {
    id: "20",

    data: {
      label: (
        <>
          <strong>Vertical Align</strong>
          <p>
            {" "}
            When your display is inline, inline-block, or a table cell box you
            set the vertical alignment of an element with this property.
          </p>

          <p>span{`{vertical-align: _______;}`}</p>

          <p className="inlined-div-1">
            This <span className="vertical-align-item">text</span> is
            vertical-align: super; <br /> <br />
            This
            <span className="vertical-align-item2">text</span> is
            vertical-align: top; <br /> <br />
            This <span className="vertical-align-item3">text</span> is
            vertical-align: baseline; <br /> <br />
            This <span className="vertical-align-item4">text</span> is
            vertical-align: sub; <br /> <br />
            This <span className="vertical-align-item5">text</span> is
            vertical-align: text-top;
            <br /> <br />
            This <span className="vertical-align-item6">text</span> is
            vertical-align: middle;
            <br /> <br />
            This <span className="vertical-align-item7">text</span> is
            vertical-align: bottom;
            <br /> <br />
            This <span className="vertical-align-item8">text</span> is
            vertical-align: text-bottom;
            <br /> <br />
            This <span className="vertical-align-item9">text</span> is
            vertical-align: 50px;
          </p>
        </>
      ),
    },
    position: { x: 1492, y: 3162 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "21",
    data: {
      label: (
        <>
          <strong>Text Styling</strong>
          <p className=""></p>
        </>
      ),
    },
    position: { x: -8, y: 2536 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 300,
    },
  },
  {
    id: "22",
    data: {
      label: (
        <>
          <strong>text-align</strong>
          <p className="">
            Specifies the horizontal alignment of text in an element.
          </p>
          <p>
            {`.item1{text-align: left}`}
            <br />
            {`.item2{text-align: right}`}
            <br />
            {`.item3{text-align: center}`}
            <br />
            {`.item4{text-align: justify}`}
            <br />
            {`.item5{text-align: inherit}`}
          </p>
          <div className="text-align-code">
            <p className="align-left-code">Item 1 is aligned left</p> <br />
            <p className="align-right-code">Item 2 is aligned right</p> <br />
            <p className="align-center-code">Item 3 is aligned center</p> <br />
            <p className="align-justify-code">Item 4 is aligned justify</p>{" "}
            <br />
            <p className="align-inherit-code">Item 5 is aligned inherit</p>
          </div>
        </>
      ),
    },
    position: { x: -157, y: 4068 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "23",
    data: {
      label: (
        <>
          <strong>font-family</strong>
          <p className="">Specifies the font used for text</p>
          <p>
            {`.item1{font-family: Arial, Helvetica, sans-serif;}`}
            <br />
            {`.item2{font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;}`}
            <br />
            {`.item3{font-family: Georgia, "Times New Roman", Times, serif}`}
          </p>
          <div className="font-family-code">
            <p className="arial-font">
              This paragraph aka .item1 is Arial, Helvatica or sans-serif font
              depending on the browser used.
            </p>{" "}
            <br />
            <p className="impact-font">
              This paragraph aka .item2 is Impact, Haettenschweiler, Arial
              Narrow Bold, or sans-serif font depending on the browser used.
            </p>{" "}
            <br />
            <p className="georgia-font">
              This paragraph aka .item3 is Georgia, Times New Roman, or Times
              serif font depending on the browser used.
            </p>
          </div>
        </>
      ),
    },
    position: { x: 460, y: 2710 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "24",
    data: {
      label: (
        <>
          <strong>font-weight</strong>
          <p className="">
            Sets the boldness of the font. The weights available depend on the
            font-family that is currently set.
          </p>

          <p>
            {`.item1{font-weight: bold;}`}
            <br />
            {`.item2{font-weight: lighter;}`}
            <br />
            {`.item3{font-weight: bolder;}`}
            <br />
            {`.item4{font-weight: 900;}`}
          </p>
          <div className="font-family-code">
            <p className="bold-1">Item 1 is bold</p>
            <p className="bold-2">Item 2 is lighter</p>
            <p className="bold-3">Item 3 bolder</p>
            <p className="bold-4">Item 4 is 900</p>
          </div>
        </>
      ),
    },
    position: { x: -158, y: 2710 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "25",
    data: {
      label: (
        <>
          <strong>font-size</strong>
          <p className="">
            Sets the text size. Font size functions differently depending on the
            value you use as demonstrated below.
          </p>
          <p className="font-size-item-1"> {`.item1{font-size: 20px;}`}</p>
          <br />
          <p> Item 2 below has a font size of 5px.</p>
          <p className="font-size-item-2"> {`.item2{font-size: 5px;}`}</p>
          <br />
          <p>
            To allow users to resize the text, use em instead of pixels. The
            default text size in browsers is 16px. So, the default size of 1em
            is 16px. The size can be calculated from pixels to em using this
            formula: pixels/16=em.
          </p>
          <p> Item 3's font-size is 2.5em which is the same as 40px. </p> <br />
          <p className="font-size-item-3">
            {`.item3{font-size: 2.5em}:`}{" "}
          </p>{" "}
          <p>
            Unfortunately, there is still a problem with older versions of
            Internet Explorer. The text becomes larger than it should when made
            larger, and smaller than it should when made smaller. The solution
            that works in all browsers, is to set a default font-size in percent
            for the {`<body>`} element.
          </p>
          <div className="em-body">
            <p className="font-size-item-3">
              {`Em and % Example:`} <br />
              {`body{font-size: 100%}`} <br />
              {`.item4{font-size: 2.5em}`}
            </p>
          </div>
          <p>
            The text size can be set with a vw unit, which means the "viewport
            width". That way the text size will follow the size of the browser
            window. Viewport is the browser window size. 1vw = 1% of viewport
            width. If the viewport is 50cm wide, 1vw is 0.5cm.
          </p>
          <p>
            {" "}
            Item 5's font size is 2vw, resize the browser window to see this
            effect.{" "}
          </p>
          <p className="vw-10">{`.item5{font-size: 10vw}`}</p>
        </>
      ),
    },
    position: { x: -778, y: 2710 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "26",
    data: {
      label: (
        <>
          <strong>font-style</strong>
          <p className="">
            Sets whether a font should be normal, italic, or oblique face. The
            font is normal font-style by default.
          </p>
          <p>
            {`.item1{font-style: italic}`}
            <br />
            {`.item3{font-style: oblique}`}
            <br />
          </p>
          <div>
            <p className="italic-font">Item 1 is italic</p>
            <p className="oblique-font">Item 2 is oblique</p>
          </div>
        </>
      ),
    },
    position: { x: -158, y: 3478 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "27",
    data: {
      label: (
        <>
          <strong>Color</strong>
          <p>
            Changes the color of an element. You can use hexadecimal values, rgb
            values, and more. See examples below.{" "}
          </p>

          <div>
            <p className="color-1">
              {" "}
              <br />
              {`.item1{color: yellow;}`}{" "}
            </p>
            <p className="color-2">
              {" "}
              Hexadecimal value: <br />
              {`.item2{color: #00FF00}`}
            </p>
            <p className="color-3">
              {" "}
              RGB value: <br />
              {`.item3{color: rgb(255,0,0);}`}
            </p>
          </div>
        </>
      ),
    },
    position: { x: 562, y: 5018 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "28",
    data: {
      label: (
        <>
          <strong>background-color</strong>
          <p className="">Sets the background color of an element.</p>
          <p>
            Note: This property works on any element, so it can be used for more
            than just text styling.{" "}
          </p>

          <p>{`.item1{background-color: blue};`}</p>
          <p className="background-color-1">Item 1 </p>
        </>
      ),
    },
    position: { x: 562, y: 5644 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "29",
    data: {
      label: (
        <>
          <strong>Padding</strong>
          <p className="">
            {" "}
            Sets the space around an element's content, inside of any defined
            borders.
          </p>
          <div>
            <p className="padding-1"> .item1{`{padding-top: 50px;}`} </p>
            <p className="padding-2">.item2{`{padding-right: 30px;}`} </p>
            <p className="padding-3">.item3{`{padding-bottom: 90px;}`} </p>
            <p className="padding-4"> .item4{`{ padding-left: 80px;}`}</p>
            <p className="padding-5"> .item5{`{ padding: 50px;}`}</p>
          </div>
        </>
      ),
    },
    position: { x: -4392, y: 1440 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "30",
    data: {
      label: (
        <>
          <strong>border-radius:</strong>
          <p>Changes the roundness of the borders</p>

          <p className="round-border">
            Round border <br />
            {`.border1{border-style: solid;`}
            <br />
            {`border-radius: 10px`}
            <br />
          </p>
          <p className="rounder-border">
            Rounder Border <br />
            {`.border2{border-style: solid;`}
            <br />
            {`border-radius: 50px`}
          </p>
        </>
      ),
    },
    position: { x: 2570, y: 1964 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "31",
    data: {
      label: (
        <>
          <strong>Width</strong>
          <p>Set an element's width</p>

          <p className="width-1">
            Set the width with pixels <br />
            {`.box1{width: 120px}`}
          </p>

          <p className="width-2">
            Set the width with em <br />
            {`.box2{width: 12em}`}
          </p>

          <p className="width-3">
            Set the width with % <br />
            {`.box3{width: 75%}`}
          </p>

          <p className="width-4">
            Set the width with auto <br />
            {`.box4{width: auto}`}
          </p>
        </>
      ),
    },
    position: { x: -3762, y: 1442 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "32",
    data: {
      label: (
        <>
          <strong>Height</strong>
          <p>Set an element's height</p>

          <p className="height-1">
            Set the height with pixels <br />
            {`.box1{height: 120px}`}
          </p>

          <p className="height-2">
            Set the height with em <br />
            {`.box2{height: 12em}`}
          </p>

          <p className="height-3">
            Set the height with % <br />
            {`.box3{height: 75%}`}
          </p>

          <p className="height-4">
            Set the height with auto <br />
            {`.box4{height: auto}`}
          </p>
        </>
      ),
    },
    position: { x: -3126, y: 1442 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "33",
    data: {
      label: (
        <>
          <strong>Position</strong>
          <p>
            There are 5 different position values; static, relative, fixed,
            absolute, and sticky. <br />
            <br />
            Since elements are positioned static by default, we can ignore
            covering that one.
          </p>
        </>
      ),
    },
    position: { x: -1756, y: 170 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "34",
    data: {
      label: (
        <>
          <strong>Relative</strong>
          <p>
            An element with position: relative; is positioned relative to its
            normal position. Setting the top, right, bottom, and left properties
            of a relatively-positioned element will cause it to be adjusted away
            from its normal position. Other content will not be adjusted to fit
            into any gap left by the element.
          </p>
          <p className="position-relative-example1">
            {`p{position: relative;
                left: 30px;
              }`}
          </p>
          <p className="position-relative-example2">
            {`p{position: relative;
                right: 30px;
                }`}
          </p>
          <p className="position-relative-example3">
            {`p{position: relative;
                top: 20px;
                }`}
          </p>
          <p className="position-relative-example4">
            {`p{position: relative;
                bottom: -20px;
               }`}
          </p>
        </>
      ),
    },
    position: { x: -1436, y: 500 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "35",
    data: {
      label: (
        <>
          <strong>Absolute</strong>
          <p className="">
            An element with position: absolute; is positioned relative to the
            nearest positioned ancestor. If an absolute positioned element has
            no positioned ancestors, it uses the document body, and moves along
            with page scrolling. <br /> <br />
            Note: Absolute positioned elements are removed from the normal flow,
            and can overlap elements, be extra hesitant using this property.
          </p>

          <div className="div-relative">
            {" "}
            This is a relative div <br />
            {`.div-relative{position: relative;  `}
            <br /> {`width: 300px;`} <br /> {`height: 110px;}`}
            <div className="div-absolute">
              This is an absolute div <br />{" "}
              {`.div-absolute{position: absolute;`} <br />
              {`bottom: 1;}`}
            </div>
          </div>
        </>
      ),
    },
    position: { x: -2280, y: 500 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "36",
    data: {
      label: (
        <>
          <strong>Fixed</strong>
          <p className="">
            An element with position: fixed; is positioned relative to the
            viewport, which means it always stays in the same place even if the
            page is scrolled. The top, right, bottom, and left properties are
            used to position the element. A fixed element does not leave a gap
            in the page where it would normally have been located.
          </p>
          <p>
            <iframe
              height="600"
              width="100%"
              scrolling="no"
              title="Fixed position"
              src="https://codepen.io/jonathanelias1/embed/preview/yLjLyRb?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/yLjLyRb">
                Fixed position
              </a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: -2277, y: 1100 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "37",
    data: {
      label: (
        <>
          <strong>Sticky</strong>
          <p className="">
            An element with position: sticky; is positioned based on the user's
            scroll position. A sticky element toggles between relative and
            fixed, depending on the scroll position. <br />
            <br />
            It is positioned relative until a given offset position is met in
            the viewport - then it "sticks" in place (like position: fixed).
          </p>
          <p>
            <iframe
              height="350"
              width="100%"
              scrolling="no"
              title="Sticky Position"
              src="https://codepen.io/jonathanelias1/embed/preview/wvjvBPv?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/wvjvBPv">
                Sticky Position
              </a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: -1434, y: 1100 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "38",
    data: {
      label: (
        <>
          <strong>:hover</strong>
          <p>
            The :hover selector is used to select elements when you mouse over
            them.
            <br /> <br />
            The :hover selector can be used on all elements, not only on links.
            <br /> <br />
            Use the :link selector to style links to unvisited pages, the
            :visited selector to style links to visited pages, and the :active
            selector to style the active link.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="Hover CSS property"
            src="https://codepen.io/jonathanelias1/embed/preview/jOxqxra?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/jOxqxra">
              Hover CSS property
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -980, y: 4434 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "39",
    data: {
      label: (
        <>
          <strong>border:</strong>
          <p className="">
            Allows you to specify the style, width, and color of an element's
            border
            <br /> <br />
            Syntax <br /> <br />
            <p>border: border-width-value border-style border-color</p>
          </p>
          <p className="border-example-1">
            .item1 {`{border: 1px solid red;}`}{" "}
          </p>
          <br />
          <p className="border-example-2">
            .item2{`{border: 5px dotted blue}`}
          </p>{" "}
          <br />
          <p className="border-example-3">
            .item3{`{border: 10px inset orange;}`}
          </p>
          <br />
          <p className="border-example-4">
            .item4{`{border: 20px dashed green;}`}
          </p>{" "}
          <br />
          <p className="double-border">
            .item5{`p.double {border-style: double;}`}
          </p>
          <br />
          <p className="groove-border">
            .item6{`p.groove {border-style: groove;}`}
          </p>{" "}
          <br />
          <p className="ridge-border">
            .item7{`p.ridge {border-style: ridge;} `}
          </p>
          <br />
          <p className="outset-border">
            .item8{`p.outset {border-style: outset;}`}
          </p>
          <br />
          <p className="mixed-border">
            .item9{`p.mix {border-style: dotted dashed solid double;}`}`
          </p>
        </>
      ),
    },
    position: { x: 2470, y: 480 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "40",
    data: {
      label: (
        <>
          <strong>text-decoration</strong>
          <p className="">
            Sets the appearance of decorative lines of text.
            <br /> <br />
            Syntax <br /> <br />
            <a className="syntax">
              text-decoration: text-decoration-line text-decoration-color
              text-decoration-style text-decoration-thickness
            </a>
          </p>
          <p className="text-decoration-example-1">
            .item1{`{text-decoration: underline yellow solid 1px;}`}
          </p>
          <p className="text-decoration-example-2">
            .item2{`{text-decoration: overline yellow double 2px;}`}
          </p>
          <p> .item3{`{text-decoration: line-through yellow dotted 3px;}`}</p>
          <p className="text-decoration-example-3">Item 3</p>
          <p className="text-decoration-example-4">
            .item4{`{text-decoration: underline yellow dashed 4px;}`}
          </p>{" "}
          <p>
            .item5{" "}
            {`{text-decoration: underline overline line-through yellow wavy 5px;}`}
          </p>
          <p className="text-decoration-example-5">Item 5</p>
          <p className="underline-2">
            {`.item6{text-decoration: yellow underline dotted;}`}
          </p>
          <p className="underline-3">{`.item7{text-decoration: yellow wavy underline;}`}</p>{" "}
          <p className="underline-4">{`.item8{text-decoration: underline overline yellow;}`}</p>
          <p>{`.item9{text-decoration: yellow dashed line-through;}`}</p>
          <p className="underline-5">Item 9</p>
          <p>{`.item10{text-decoration: underline line-through yellow;}`}</p>
          <p className="underline-7">Item 10</p>
          <p className="underline-8">{`.item11{text-decoration: yellow underline double 5px;}`}</p>
        </>
      ),
    },
    position: { x: 461, y: 3664 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "41",

    data: {
      label: (
        <>
          <strong>Borders</strong>
        </>
      ),
    },
    position: { x: 2720, y: 170 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 300,
    },
  },

  {
    id: "42",

    data: {
      label: (
        <>
          <strong>Sizing Elements</strong>
          <p>
            To size an element you will generally use either the width, height,
            padding, or transform: scale() property. <br /> <br />
            The difference between Width/Height and transform: scale() is that
            while using scale, it will resize from the center of the object,
            while using Width/Height will start from the top left (unless you
            change the transform origin). <br /> <br />
            Also if you use Scale and the object has content, it will also scale
            everything inside, while Width/Height will not.
            <br /> <br />
            Adding min-width/max-width/min-height/max-height can be very useful
            when resizing a webpage for mobile.
            <br /> <br />
            To learn more about the transform: scale() property go here. <br />
            <br />
            <Link className="link-to-advanced-styling" to="/styling">
              Advanced Styling
            </Link>
          </p>
        </>
      ),
    },
    position: { x: -3956, y: 170 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  {
    id: "43",
    data: {
      label: (
        <>
          <strong>min-width</strong>
          <p>
            Prevents the value of the width property from becoming smaller than
            min-width.
            <br />
            <br />
            If the content is smaller than the minimum width, the minimum width
            will be applied otherwise, it will have no effect.
          </p>
          <br />
          <p>A min-width value of none is the default value for min-width.</p>
          <br />
          <p className="min-width-1">{`.box1{min-width: none;)}`}</p>
          <br /> <br />
          <p>Watch how this changes when the min-width value is 250.</p> <br />
          <p className="min-width-2">{`.box1{min-width: 250px;)}`}</p>
        </>
      ),
    },
    position: { x: -5294, y: 2700 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "44",
    data: {
      label: (
        <>
          <strong>max-width</strong>
          <p>
            Prevents the value of the width property from becoming larger than
            max-width.
            <br />
            <br />
            If the content is larger than the minimum width, the height of the
            element will be changed otherwise, it will have no effect.
          </p>
          <p>A max-width value of none is the default value for max-width.</p>
          <br />
          <p className="max-width-1">{`.box1{max-width: none;)}`}</p>
          <br /> <br />
          <p>Watch how this changes when the max-width value is 100.</p>
          <br />
          <p className="max-width-2">{`.box1{max-width: 100px;)}`}</p>
        </>
      ),
    },
    position: { x: -4418, y: 2700 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "45",
    data: {
      label: (
        <>
          <strong>min-height</strong>
          <p>
            Prevents the value of the height property from becoming smaller than
            min-height.
            <br />
            <br />
            If the content is smaller than the minimum height, the minimum
            height will be applied otherwise, it will have no effect.
          </p>
          <br />
          <p>A min-height value of none is the default value for min-height.</p>
          <br />
          <p className="min-height-1">{`.box1{min-height: none;)}`}</p>
          <br /> <br />
          <p>Watch how this changes when the min-height value is 150.</p> <br />
          <p className="min-height-2">{`.box1{min-height: 150px;)}`}</p>
        </>
      ),
    },
    position: { x: -3562, y: 2625 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "46",
    data: {
      label: (
        <>
          <strong>max-height</strong>
          <p>
            Prevents the value of the height property from becoming larger than
            max-height.
          </p>
          <br />
          <p className="max-height-1">
            {`.box1{max-height: none;)`} <br />
            {`height: 200px;)}`}
          </p>
          <br /> <br />
          <p>Watch how this changes when the max-height value is 100.</p> <br />
          <p className="max-height-2">
            {`.box1{max-height: 100px;)`}
            <br />
            {`height: 200px;)}`}
          </p>
        </>
      ),
    },
    position: { x: -2715, y: 2648 },
    style: {
      background: level5,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "47",
    data: {
      label: (
        <>
          <strong>box-sizing</strong>
          <p>
            box-sizing: border-box; is essential towards simplifying your css. I
            strongly recommend doing html{`{box-sizing: border-box;}`} at the
            top of your css code for everything you create.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="box-sizing"
            src="https://codepen.io/jonathanelias1/embed/preview/RwyEmEZ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/RwyEmEZ">
              box-sizing
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -5599, y: 1440 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "48",
    data: {
      label: (
        <>
          <strong>Left, Right, Top, Bottom</strong>
          <p className="">
            The top, bottom, left, and right properties are used with position
            to set the placement of an element. They only have an effect on
            positioned elements, which are elements with the position property
            set to anything other than static. For example: relative, absolute,
            fixed, or sticky.
            <br />
            <br />
            Utilize this to orient your positioned elements.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="opacity"
            src="https://codepen.io/jonathanelias1/embed/preview/OJZGBRP?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/OJZGBRP">opacity</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1822, y: 2176 },
    style: {
      background: level6,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  // End of items
];

export const edges = [
  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-7",
    source: "1",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-8",
    source: "1",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-12",
    source: "1",
    target: "12",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-21",
    source: "1",
    target: "21",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-33",
    source: "1",
    target: "33",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-41",
    source: "1",
    target: "41",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-42",
    source: "1",
    target: "42",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Margin
  {
    id: "e2-3",
    source: "2",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e2-4",
    source: "2",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e2-5",
    source: "2",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e2-6",
    source: "2",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //CSS CLASSES
  {
    id: "e7-8",
    source: "7",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Targeting multiple elements at once
  {
    id: "e8-9",
    source: "8",
    target: "9",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e8-10",
    source: "8",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e8-11",
    source: "8",
    target: "11",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //DISPLAY
  {
    id: "e12-13",
    source: "12",
    target: "13",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e12-14",
    source: "12",
    target: "14",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e12-15",
    source: "12",
    target: "15",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e12-16",
    source: "12",
    target: "16",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e12-17",
    source: "12",
    target: "17",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e12-18",
    source: "12",
    target: "18",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e12-19",
    source: "12",
    target: "19",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e13-20",
    source: "13",
    target: "20",
    animated: true,
    style: { stroke: "#f6ab6c" },
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e15-20",
    source: "15",
    target: "20",
    animated: true,
    style: { stroke: "#f6ab6c" },
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //TEXT STYLING

  {
    id: "e21-22",
    source: "21",
    target: "22",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e21-23",
    source: "21",
    target: "23",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-24",
    source: "21",
    target: "24",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-25",
    source: "21",
    target: "25",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-26",
    source: "21",
    target: "26",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-27",
    source: "21",
    target: "27",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-28",
    source: "21",
    target: "28",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-38",
    source: "21",
    target: "38",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e21-40",
    source: "21",
    target: "40",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //BASIC STYLING
  // {
  //   id: "e41-28",
  //   source: "41",
  //   target: "28",
  //   // label: "this is an edge label",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  {
    id: "e41-39",
    source: "41",
    target: "39",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e39-30",
    source: "39",
    target: "30",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //POSITION
  {
    id: "e33-34",
    source: "33",
    target: "34",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-35",
    source: "33",
    target: "35",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-36",
    source: "33",
    target: "36",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-37",
    source: "33",
    target: "37",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e33-48",
    source: "33",
    target: "48",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //SIZING ELEMENTS
  {
    id: "e42-31",
    source: "42",
    target: "31",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e42-32",
    source: "42",
    target: "32",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e42-29",
    source: "42",
    target: "29",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e31-43",
    source: "31",
    target: "43",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e31-44",
    source: "31",
    target: "44",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e32-45",
    source: "32",
    target: "45",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e32-46",
    source: "32",
    target: "46",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e42-37",
    source: "42",
    target: "47",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e27-28",
    source: "27",
    target: "28",
    animated: true,
    style: { stroke: "#f6ab6c" },
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Animated Example
  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  // markerEnd: {
  //   type: MarkerType.ArrowClosed,
  // },
  //   },

  //END
];
